/**
 * Whether to allow MFA sign-in with correct code and incorrect password.
 * As MFA will mostly be triggered at the email step, we allow sign-in with correct code and incorrect password
 * at the password step to reduce confusion on which credential is incorrect.
 * Design Doc: https:docs.google.com/document/d/1QkF_IkOUSiof0uSi5k1KJwDHC2v2Tv5Vj6gbchmSZZk/
 */ export var ENABLE_MFA_WITH_CORRECT_CODE_INCORRECT_PASSWORD_250211 = 'ENABLE_MFA_WITH_CORRECT_CODE_INCORRECT_PASSWORD_250211';
